import React from 'react'
import glamorous from 'glamorous'
import content from 'pp-react-l10n'
import { css } from '../../../lib/paypalphrodite'
import styles from '../funding-option-selector.styles'
import PropTypes from 'prop-types'
import pendingSVG from './icons/svg/pending.svg'
import glamorousIcon from '../../../lib/glamorous-icon'
import { trackImpression, trackLink } from '../../../lib/analytics/fpti'
let i18n = content('transfer/nobalance')

const Box = glamorous.div({
  display: 'block',
  justifyContent: 'center',
  marginTop: '10%',
})
const Heading = glamorous.h2({
  width: '50%',
  marginLeft: '25%',
  marginBottom: '2%',
})

const SubText = glamorous.p({
  width: '60%',
  marginLeft: '20%',
  marginBottom: '5%',
})
const ProfileIconSVG = glamorousIcon({
  height: 80,
  width: 80,
  marginLeft: '45%',
  '& svg': { height: 80, width: 80 },
})

ProfileIconSVG.defaultProps = { svg: pendingSVG }

export class CIPManualReview extends React.Component {
  static propTypes = {
    handleNext: PropTypes.func.isRequired,
  }

  componentDidMount() {
    this.analyticsStrings = {
      pageGroup: 'main:consumer:p2p:nobalance:manualreview',
      pageName: 'main:consumer:p2p:nobalance:manualreview:overpanel::',
    }
    trackImpression(
      this.analyticsStrings.pageGroup,
      this.analyticsStrings.pageName
    )
  }

  render() {
    return (
      <Box
        role="dialog"
        aria-label={i18n('nobalance.manualReviewTitle')}
        tabIndex="-1"
        data-a11y-overpanel-focus-target="manual-review-open"
        css={{
          ':focus': {
            outline: 'none',
          },
        }}
      >
        <ProfileIconSVG />
        <Heading className="txtCenter ppvx_text--xl3">
          {i18n('nobalance.manualReviewTitle')}
        </Heading>
        <SubText className="txtCenter vx_text-8_lighter">
          {i18n('nobalance.manualReviewSubTitle')}
        </SubText>
        <button
          data-nemo="nobalance-manualreview-next-button"
          onClick={() => {
            const { pageGroup, pageName } = this.analyticsStrings
            trackLink('next', pageGroup, pageName, 'link')
            this.props.handleNext()
          }}
          className={`${css(styles.nextButton)} vx_btn`}
        >
          {i18n('nobalance.manualReviewNext')}
        </button>
      </Box>
    )
  }
}

export default CIPManualReview
